import { render, staticRenderFns } from "./PresentationBlock.vue?vue&type=template&id=133f9790&"
import script from "./PresentationBlock.vue?vue&type=script&lang=js&"
export * from "./PresentationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports